// src/components/HomeButton/HomeButton.js

import React from "react";
import { useNavigate } from "react-router-dom";

const HomeButton = () => {
  const navigate = useNavigate();

  return (
    <div className="absolute flex space-x-4 transform -translate-x-1/2 top-6 left-1/2">
      <button
        onClick={() => navigate(-1)}
        className="px-4 py-2 text-white transition duration-300 ease-in-out transform rounded-full shadow-md bg-gradient-to-r from-pink-500 to-red-500 hover:from-red-600 hover:to-pink-600 hover:scale-105"
      >
        Back
      </button>
      <button
        onClick={() => navigate("/")}
        className="px-4 py-2 text-white transition duration-300 ease-in-out transform rounded-full shadow-md bg-gradient-to-r from-purple-500 to-blue-500 hover:from-blue-600 hover:to-purple-600 hover:scale-105"
      >
        Return Home
      </button>
    </div>
  );
};

export default HomeButton;
